module.exports = __webpack_public_path__ + "img/parque_logo.1ed9a52e.png";